<!-- 首页底部 -->
<template>
  <div class="home-bottom">
    <ul>
      <li v-for="(item,index) in menuList"
          :key="index">
        <router-link :to="item.path">{{item.name}}</router-link>
      </li>
    </ul>
    <div class="home-bottom-copy" v-html="copyright"></div>
  </div>
</template>

<script>
// less
import './home.less'
import { copyright } from '@/constant'
export default {
  name: 'home-bottom',
  components: {},
  data () {
    return {
      copyright,
      menuList: [
        {
          name: '最新动态',
          path: '/news'
        },
        {
          name: '火炬计划',
          path: '/torch'
        },
        {
          name: '绑定微信',
          path: '/wx'
        },
        {
          name: '问题反馈',
          path: '/feedback'
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
